import { useParams } from "react-router-dom";
import "./UserActivityLogsPage.scss";
import ActivityLogsPage from "../../../components/ActivityLogsPage/ActivityLogsPage";
import { GetCalendarDataForLogs, GetUserActivityLogs } from "../../../utils/apiCalls/logs";

const UserActivityLogsPage = () => {
  // Keying on the route param forces a full remount when navigating between
  // different users' logs, so filters/pagination/date state never leak across ids.
  const { userId } = useParams();
  return (
    <ActivityLogsPage
      key={userId}
      idParam="userId"
      fetchLogs={GetUserActivityLogs}
      fetchCalendar={GetCalendarDataForLogs}
      backRoute="/logs"
      defaultFromTab="user"
    />
  );
};

export default UserActivityLogsPage;
